/**
 * Featured Products & Videos Tabs - Sleek Theme OS 2.0
 */
if (!customElements.get('featured-products-tab')) {
  customElements.define(
    'featured-products-tab',
    class FeaturedProductsTab extends HTMLElement {
      constructor() {
        super();
        this.tabButtons = Array.from(this.querySelectorAll('[role="tab"]'));
        this.tabPanels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
        this.selectDropdown = this.querySelector('[data-mobile-select]');
        this.mobileDesc = this.querySelector('[data-mobile-desc]');
      }

      connectedCallback() {
        this.bindEvents();
      }

      bindEvents() {
        // Desktop / tablet tab click
        this.tabButtons.forEach((btn, index) => {
          btn.addEventListener('click', () => this.setActiveTab(index));
        });

        // Mobile select dropdown change
        if (this.selectDropdown) {
          this.selectDropdown.addEventListener('change', (e) => {
            this.setActiveTab(parseInt(e.target.value, 10));
          });
        }

        // Video play buttons
        const playButtons = this.querySelectorAll('[data-play-trigger]');
        playButtons.forEach((btn) => {
          btn.addEventListener('click', (e) => {
            e.stopPropagation();
            const card = btn.closest('.featured-tabs__card');
            if (!card) return;
            const video = card.querySelector('video');
            if (video) {
              if (video.paused) {
                video.play();
                btn.style.opacity = '0';
              } else {
                video.pause();
                btn.style.opacity = '1';
              }
            }
          });
        });
      }

      setActiveTab(index) {
        if (index < 0 || index >= this.tabPanels.length) return;

        // Update tab buttons
        this.tabButtons.forEach((btn, i) => {
          const isSelected = i === index;
          btn.setAttribute('aria-selected', isSelected ? 'true' : 'false');
          btn.classList.toggle('is-active', isSelected);
        });

        // Update tab panels
        this.tabPanels.forEach((panel, i) => {
          const isSelected = i === index;
          panel.classList.toggle('is-active', isSelected);
          panel.setAttribute('aria-hidden', isSelected ? 'false' : 'true');
        });

        // Update mobile dropdown
        if (this.selectDropdown && this.selectDropdown.value !== String(index)) {
          this.selectDropdown.value = String(index);
        }

        // Update mobile description
        if (this.mobileDesc) {
          const activeDesc = this.tabButtons[index]?.querySelector('.featured-tabs__tab-desc')?.textContent;
          if (activeDesc) {
            this.mobileDesc.textContent = activeDesc;
          }
        }
      }
    }
  );
}
